import { handleUnauthorized } from "./authSession";

export async function loadAuth() {
  const token = localStorage.getItem("authToken");
  if (!token) return null;

  const baseUrl = (import.meta.env.VITE_BASE_URL || "").replace(/\/$/, "");
  const res = await fetch(`${baseUrl}/auth/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (res.status === 401) {
    handleUnauthorized();
    return null;
  }

  if (!res.ok) return null;

  const body = await res.json();
  return body?.data ?? body;
}
